var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path, _path2, _line, _path3, _path4, _circle0, _path5, _path6, _path7, _path8, _circle1, _path9, _path0, _path1, _path10, _path11, _path12, _circle10, _line2, _ellipse, _path13, _circle11, _path14, _path15, _line3, _line4, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4bc190;}.cls-12,.cls-2{fill:#356cb6;}.cls-2{opacity:0.3;}.cls-3{fill:#fff;}.cls-4{fill:#fbc0aa;}.cls-5{fill:#515570;}.cls-10,.cls-6{fill:none;stroke:#fbc0aa;stroke-linecap:round;stroke-linejoin:round;}.cls-6{stroke-width:20px;}.cls-7,.cls-8{fill:#393c54;}.cls-12,.cls-8{opacity:0.1;}.cls-9{fill:#ffd8c9;}.cls-10{stroke-width:2px;}.cls-11{fill:#f85565;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 60
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 64,
    cy: 64,
    r: 48
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 30.76,
    cy: 59.37,
    r: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 97.24,
    cy: 59.37,
    r: 10
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 32.76,
    cy: 41.77,
    r: 12.43
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 95.24,
    cy: 41.77,
    r: 12.43
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 44.5,
    cy: 25.34,
    r: 12.43
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 83.5,
    cy: 25.34,
    r: 12.43
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 91.32,
    cy: 64.43,
    r: 7.93
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64,124.1a59.78,59.78,0,0,0,40-15.28l-2.39-5.68c-1.71-4-6.22-6.64-11.29-6.64H37.69c-5.07,0-9.58,2.66-11.29,6.64L24,108.82A59.78,59.78,0,0,0,64,124.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M79,96.5H48.85A15.07,15.07,0,0,0,79,96.5Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 64,
    x2: 64,
    y1: 84.75,
    y2: 98.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M64,113l9.66,3.51a1,1,0,0,0,1.34-.94V104.43a1,1,0,0,0-1.34-.94L64,107Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M64,113l-9.66,3.51a1,1,0,0,1-1.34-.94V104.43a1,1,0,0,1,1.34-.94L64,107Z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 64,
    cy: 110,
    r: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64,103.25a11,11,0,0,1-10.78-8.8,11.4,11.4,0,0,0-.22,2.2,11,11,0,0,0,22,0,11.4,11.4,0,0,0-.22-2.2A11,11,0,0,1,64,103.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M64,103.25a11,11,0,0,1-10.78-8.8,11.4,11.4,0,0,0-.22,2.2,11,11,0,0,0,22,0,11.4,11.4,0,0,0-.22-2.2A11,11,0,0,1,64,103.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.78,101.1,64,105.74l-8.78-4.64a.9.9,0,0,0-1.22.7v8.4a.9.9,0,0,0,1.22.7L64,106.26l8.78,4.64a.9.9,0,0,0,1.22-.7v-8.4A.9.9,0,0,0,72.78,101.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M72.78,101.1,64,105.74l-8.78-4.64a.9.9,0,0,0-1.22.7v8.4a.9.9,0,0,0,1.22.7L64,106.26l8.78,4.64a.9.9,0,0,0,1.22-.7v-8.4A.9.9,0,0,0,72.78,101.1Z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 36.68,
    cy: 64.43,
    r: 7.93
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M64,98.37A28.31,28.31,0,0,1,35.68,70.05V55.43a28.32,28.32,0,1,1,56.64,0V70.05A28.31,28.31,0,0,1,64,98.37Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M60,94a7,7,0,0,1,8,0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M71.55,80a1,1,0,0,1,.94,1.07,8.56,8.56,0,0,1-17,0A1,1,0,0,1,56.45,80Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M64,92h0a4,4,0,0,1-4-4V77h8V88A4,4,0,0,1,64,92Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.25,82.26C51.25,76.59,56.93,72,63.92,72s12.67,4.59,12.67,10.26"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64,77h0a5,5,0,0,1-5-5V57H69V72A5,5,0,0,1,64,77Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 50,
    cy: 62.51,
    r: 3.15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 56,
    x2: 72,
    y1: 45,
    y2: 45
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 63.91,
    cy: 24.95,
    rx: 18.28,
    ry: 16.82
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M80.83,18.58c-.41,10.66-9.9,19.19-21.58,19.19A23.05,23.05,0,0,1,50,35.83a18.9,18.9,0,0,0,13.93,5.94C74,41.77,82.19,34.24,82.19,25A15.72,15.72,0,0,0,80.83,18.58Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 78,
    cy: 62.51,
    r: 3.15
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87,53.77c-.4,1.69-10.86.65-12.55.25a3.15,3.15,0,1,1,1.46-6.12C77.58,48.3,87.38,52.08,87,53.77Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41,53.77c.4,1.69,10.86.65,12.55.25a3.15,3.15,0,0,0-1.46-6.12C50.42,48.3,40.62,52.08,41,53.77Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 75,
    x2: 81,
    y1: 69,
    y2: 69
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 47,
    x2: 53,
    y1: 69,
    y2: 69
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M104,108.82l-2.39-5.68c-1.71-4-6.22-6.64-11.29-6.64H77l-.4,26.26A59.82,59.82,0,0,0,104,108.82Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M23.59,108.82,26,103.14c1.71-4,6.23-6.64,11.29-6.64H50.59l.4,26.26A59.82,59.82,0,0,1,23.59,108.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessorIcon);
export default __webpack_public_path__ + "static/media/professor_icon.92b20bd6dd0caa00f07094adc77cbd2b.svg";
export { ForwardRef as ReactComponent };